/**
 * Random congratulatory toast key for student i18n (congrats.msg0 … msg9).
 * Shown when students get 3 correct answers in a row.
 */

export const STUDENT_CONGRATS_COUNT = 10;

export function getRandomStudentCongratsKey(): string {
  const index = Math.floor(Math.random() * STUDENT_CONGRATS_COUNT);
  return `congrats.msg${index}`;
}
